import React from 'react';
import styled from 'styled-components';

import { Field } from '@ontruck/orc';

const StyledWrapper = styled.div`
  position: relative;
  margin-top: -1px;
`;

const StyledFieldWrapper = (props) => (
  <StyledWrapper>
    <Field {...props} />
  </StyledWrapper>
);

const StyledSuccess = styled.span`
  color: var(--greenKiwi);
`;

export { StyledFieldWrapper, StyledSuccess };
